import React, { useState, createContext, useContext } from 'react';
export interface Company {
  id: string;
  name: string;
  type: 'master' | 'submerchant';
  logo?: string;
  parentId?: string;
}
interface CompanyContextType {
  selectedCompany: Company;
  companies: Company[];
  setSelectedCompany: (company: Company) => void;
}
const CompanyContext = createContext<CompanyContextType | undefined>(undefined);
// Mock data for master merchant and sub-merchants
const mockCompanies: Company[] = [{
  id: 'master-001',
  name: 'Bila Bila Mart',
  type: 'master'
}, {
  id: 'submerchant-kl-001',
  name: 'Bila Bila Mart - Bukit Bintang',
  type: 'submerchant',
  parentId: 'master-001'
}, {
  id: 'submerchant-kl-002',
  name: 'Bila Bila Mart - Bangsar',
  type: 'submerchant',
  parentId: 'master-001'
}, {
  id: 'submerchant-kl-003',
  name: 'Bila Bila Mart - Petaling Jaya',
  type: 'submerchant',
  parentId: 'master-001'
}, {
  id: 'submerchant-kl-004',
  name: 'Bila Bila Mart - Mont Kiara',
  type: 'submerchant',
  parentId: 'master-001'
}, {
  id: 'submerchant-kl-005',
  name: 'Bila Bila Mart - Subang Jaya',
  type: 'submerchant',
  parentId: 'master-001'
}, {
  id: 'submerchant-kl-006',
  name: 'Bila Bila Mart - Johor Bahru',
  type: 'submerchant',
  parentId: 'master-001'
}, {
  id: 'submerchant-kl-007',
  name: 'Bila Bila Mart - Bukit Bintang',
  type: 'submerchant',
  parentId: 'master-001'
}, {
  id: 'submerchant-kl-008',
  name: 'Bila Bila Mart - Bangsar',
  type: 'submerchant',
  parentId: 'master-001'
}, {
  id: 'submerchant-kl-009',
  name: 'Bila Bila Mart - Petaling Jaya',
  type: 'submerchant',
  parentId: 'master-001'
}, {
  id: 'submerchant-kl-010',
  name: 'Bila Bila Mart - Mont Kiara',
  type: 'submerchant',
  parentId: 'master-001'
}, {
  id: 'submerchant-kl-011',
  name: 'Bila Bila Mart - Subang Jaya',
  type: 'submerchant',
  parentId: 'master-001'
}, {
  id: 'submerchant-kl-012',
  name: 'Bila Bila Mart - Johor Bahru',
  type: 'submerchant',
  parentId: 'master-001'
}];
export function CompanyProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [selectedCompany, setSelectedCompany] = useState<Company>(mockCompanies[0]);
  return <CompanyContext.Provider value={{
    selectedCompany,
    companies: mockCompanies,
    setSelectedCompany
  }} data-id="element-232">
      {children}
    </CompanyContext.Provider>;
}
export function useCompany() {
  const context = useContext(CompanyContext);
  if (context === undefined) {
    throw new Error('useCompany must be used within a CompanyProvider');
  }
  return context;
}